import configureStore from "./services/ConfigureStore";
import { initialState } from "./constants/InitialState";

const store = configureStore(initialState);

export default store;
